import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Btn from "../components/Btn";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center bg-su-bg px-4">
      <div className="card-chunky p-8 sm:p-10 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-3xl bg-su-energy/15 grid place-items-center mx-auto mb-4"><XCircle className="w-11 h-11 text-su-energy" /></div>
        <h1 className="font-heading font-black text-2xl mb-2">Pembayaran dibatalkan</h1>
        <p className="text-su-muted font-medium mb-6">Tidak ada yang ditagih. Kamu bisa mencoba lagi kapan saja.</p>
        <Link to="/pricing"><Btn className="w-full" data-testid="payment-cancel">Coba Lagi</Btn></Link>
      </div>
    </div>
  );
}
